<template>
<form @submit.prevent="handleSearch(findValue)">
  <div class="form-group search-form">
    <input class="form-control"
      v-model="findValue"/>
    <div v-if="findValue === ''"
      class="placeholder">{{placeholder}}</div>
    <btn
        type="submit"
        :class="{ 'btn-active': focused }"
        variant="settings"
      >
        <icon name="search" />
      </btn>
  </div>
</form>
</template>

<script>
import { ref } from "vue";
export default
{
  name: "SearchForm",
  props:
  {
    placeholder:
    {
      type: String,
      default: ""
    },
    handleSearch: String
  },
  setup(){

    const findValue = ref('');

    return{
      findValue
    }

  }
}
</script>

<style lang="scss" scoped>
form{
  width: 40%;
}
.search-form {
  position: relative;
  // max-width: 301px;
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 0;
  .input-wrapper {
    width: calc(100% - 40px);
  }
  &.no-title {
    padding: 0;
  }
  .btn {
    border-radius: 0 0 0 0;
    transition: all 0.3s ease;
    &.btn-active {
      border-radius: 50%;
    }
    .icon {
      color: var(--primary);
    }
    margin: 0;
    padding: 20px;
    color: white;
    box-shadow: 0 0 0 0;
    background: transparent;
    &:hover{
      background: transparent;
    }
  }
  input {
    padding: 0.5rem 0.25rem;
    margin-bottom: 0;
  }
  .search-icon {
    position: absolute;
    right: 10px;
    left: auto;
    top: auto;
    bottom: 9px;
    cursor: pointer;
    transition: color 0.3s ease;
  }
  .placeholder {
    position: absolute;
    left: 15px;
    top: auto;
    bottom: 11px;
    color: #aaaaaa;
    pointer-events: none;
  }
  .dropdown-menu {
    width: 100%;
    max-height: 310px;
    overflow: auto;
  }
  .dropdown-item {
    max-width: none;
    cursor: pointer;
  }
  .bmd-label-floating {
    top: 21px;
  }
  &.is-filled,
  &.is-focused {
    .bmd-label-floating {
      top: 0;
      left: 4px;
    }
  }
}
</style>

